import { PublicOrg } from '../../types/branding'

const API_BASE = import.meta.env.VITE_API_BASE_URL || '/v1'

export const publicOrgApi = {
  async getBySlug(slug: string): Promise<PublicOrg> {
    const response = await fetch(`${API_BASE}/public/orgs/${encodeURIComponent(slug)}`)
    if (response.status === 404) {
      const error = new Error('Organization not found') as Error & { status: number }
      error.status = 404
      throw error
    }
    if (!response.ok) {
      const error = new Error(`API error: ${response.status}`) as Error & { status: number }
      error.status = response.status
      throw error
    }
    const body = await response.json() as { org: PublicOrg }
    return body.org
  },
}
